<ng-container *transloco="let t; prefix: 'image-editor-dialog'">
    <input #imageFileInput (change)="fileChangeEvent($event)" [accept]="acceptedFilesMimetypes" hidden type="file" />

    <div
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
        class="flex flex-row justify-between items-center"
        mat-dialog-title
    >
        <h2>{{ title }}</h2>
        <button (click)="matDialogRef.close()" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="mat-typography">
        <div *ngIf="!imageUploaded" class="w-full h-full flex justify-center items-center">
            <div class="p-18 w-10/20">
                <ngx-file-drop
                    (onFileDrop)="dropped($event)"
                    (onFileLeave)="fileLeave($event)"
                    (onFileOver)="fileOver($event)"
                    *ngIf="!uploadingImage"
                    [accept]="acceptedFilesMimetypes"
                    contentClassName="file-drop-content"
                    dropZoneClassName="drop-zone"
                    [multiple]="false"
                >
                    <ng-template let-openFileSelector="openFileSelector" ngx-file-drop-content-tmp>
                        <div class="w-full h-full flex flex-col justify-center items-center gap-4 p-4">
                            <h2>Arraste a imagem até aqui</h2>
                            <span>ou clique em "fazer upload" para escolher o arquivo</span>
                            <button (click)="openFileSelector()" mat-stroked-button>Fazer upload</button>
                        </div>
                    </ng-template>
                </ngx-file-drop>
            </div>
        </div>

        <angular-cropper
            #angularCropper
            (ready)="onImageLoaded($event)"
            *ngIf="imageUploaded"
            [cropperOptions]="config"
            [imageUrl]="imageUrl"
            [settings]="settings"
        ></angular-cropper>

        <div *ngIf="uploadingImage" class="image-loader-container w-full h-full">
            <div class="w-full h-full flex flex-col justify-center items-center gap-4">
                <mat-spinner diameter="50"></mat-spinner>
                <span>{{ t("Processing File") }}.</span>
            </div>
        </div>
    </mat-dialog-content>

    <div class="flex flex-row justify-between items-center" mat-dialog-actions>
        <mat-toolbar *ngIf="imageEditorReady && !uploadingImage">
            <mat-toolbar-row>
                <span class="spacer"></span>

                <button (click)="cropAndSaveSave()" class="mat-toolbar-button" mat-button>
                    {{ t("actions.Save") }}
                </button>
                <button
                    (click)="onOpenFileExplorer($event)"
                    [matTooltip]="t('SelectOther')"
                    class="mat-toolbar-icon-button"
                    mat-button
                >
                    <mat-icon>image</mat-icon>
                </button>

                <mat-divider [vertical]="true"></mat-divider>

                <button
                    (click)="rotateLeft()"
                    [matTooltip]="t('RotateLeft')"
                    class="mat-toolbar-icon-button"
                    mat-button
                >
                    <mat-icon>rotate_left</mat-icon>
                </button>
                <button
                    (click)="rotateRight()"
                    [matTooltip]="t('RotateRight')"
                    class="mat-toolbar-icon-button"
                    mat-button
                >
                    <mat-icon>rotate_right</mat-icon>
                </button>
                <button
                    (click)="flipHorizontal()"
                    [matTooltip]="t('RotateVertical')"
                    class="mat-toolbar-icon-button"
                    mat-button
                >
                    <mat-icon>flip</mat-icon>
                </button>
                <button
                    (click)="flipVertical()"
                    [matTooltip]="t('RotateHorizontal')"
                    class="mat-toolbar-icon-button"
                    mat-button
                >
                    <mat-icon class="rotate-180">flip</mat-icon>
                </button>

                <mat-divider vertical="true"></mat-divider>

                <button (click)="zoomIn()" [matTooltip]="t('Enlarge')" class="mat-toolbar-icon-button" mat-button>
                    <mat-icon>zoom_in</mat-icon>
                </button>
                <button (click)="zoomOut()" [matTooltip]="t('Reduce')" class="mat-toolbar-icon-button" mat-button>
                    <mat-icon>zoom_out</mat-icon>
                </button>

                <mat-divider vertical="true"></mat-divider>

                <button (click)="resetImage()" [matTooltip]="t('Clean')" class="mat-toolbar-icon-button" mat-button>
                    <mat-icon>clear_all</mat-icon>
                </button>

                <span class="spacer"></span>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
</ng-container>
